export default __webpack_public_path__ + "static/media/rubik-v12-latin-500.9ed70bc7.eot";